import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";

window.addEventListener("error", (e) => {
  console.error("[Zekay] Uncaught error:", e.error ?? e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("[Zekay] Unhandled promise rejection:", e.reason);
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </Router>
  </ErrorBoundary>,
);
